import { useQuery } from '@tanstack/react-query';
import { fetchApplications } from '@/services/applicationsApi';
import { queryKeys } from '@/services/queryKeys';

/**
 * Server-state fetch for the current user's applications (/v1/applications).
 * Caching, retry, and loading/error flags come from React Query; this hook only
 * owns the query key and the fetcher wiring. Enabled only once we know the user's
 * email, since the backend requires it as a query param.
 */
export const useApplicationsQuery = (userEmail?: string) =>
  useQuery({
    queryKey: queryKeys.applications(userEmail),
    queryFn: () => fetchApplications(userEmail as string),
    enabled: Boolean(userEmail),
  });
